import { useQuery } from "@tanstack/react-query";
// import { useState } from "react";
import { useParams } from "react-router-dom";
// import { toast } from "react-toastify";

import styles from "./Header.module.scss";

import { getIssuesHeader } from "../../../../../api/issuesSummary/issuesSummary";
import { useUserData } from "../../../../../hooks/useUserProfile";
// import { useAppSelector } from "../../../../../store/hooks/hooks";
// import { selectCurrentId } from "../../../../../store/slices/stepSlice";
import { HeaderIssues } from "../../../../../types/issuesSummary";
// import { createErrorMessage } from "../../../../../utils/createErrorMessage";
import { formatDate } from "../../../../../utils/formatDate";
import { Loader } from "../../../../Loader";
import { HeaderLogo } from "../../../HederLogo";
import { HeaderFilters } from "../HeaderFilters";

export const Header = () => {
  const { syncLogId } = useParams();

  const { organizationId, tenantId } = useUserData();
  const { reportId } = useParams();

  const { data: headerList, isLoading } = useQuery({
    queryKey: ["getHeaderIssues", tenantId, reportId, syncLogId],
    queryFn: async (): Promise<HeaderIssues | undefined> => {
      const headerInfo = await getIssuesHeader(
        syncLogId!,
        organizationId,
        tenantId,
      );
      return headerInfo.data.data;
        // } catch (error) {
          // toast.error(createErrorMessage(error));
        // }
      },
    enabled: !!tenantId && !!reportId && !!syncLogId,
  });

  return (
    <div className={styles.root}>
      <HeaderLogo title={headerList?.reportName} />
      {isLoading && <Loader />}
      {!isLoading && headerList && (
        <HeaderFilters
          count={headerList?.count}
          countOpened={headerList?.countOpenedIssues}
          maxPeriod={formatDate(headerList.maxPeriod)}
          minPeriod={formatDate(headerList.minPeriod)}
          owners={headerList?.owners}
        />
      )}
    </div>
  );
};
